import { render, staticRenderFns } from "./EmergencyTicket.vue?vue&type=template&id=4bc86226"
import script from "./EmergencyTicket.vue?vue&type=script&lang=js"
export * from "./EmergencyTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports